const absence = {
  'absence.title': 'Absences',
  'absence.add': 'Add absence',
  'absence.type.KRANK_MIT_ATTEST': 'KRmA – Sick with certificate',
  'absence.type.KRANK_OHNE_ATTEST': 'KRoA – Sick without certificate',
  'absence.type.FZT': 'FZT – Comp time off day',
  'absence.form.title': 'New absence',
  'absence.form.employee': 'Employee',
  'absence.form.choose': '– Please select –',
  'absence.form.type': 'Type of absence',
  'absence.form.from': 'From',
  'absence.form.to': 'To',
  'absence.form.notes': 'Note (optional)',
  'absence.form.save': 'Save',
  'absence.form.saving': 'Saving…',
  'absence.form.cancel': 'Cancel',
  'absence.empty': 'No absences for {year}',
  'absence.col.employee': 'Employee',
  'absence.col.type': 'Type',
  'absence.col.from': 'From',
  'absence.col.to': 'To',
  'absence.col.workdays': 'Working days',
  'absence.col.notes': 'Note',
  'absence.col.createdBy': 'Entered by',
  'absence.admin': 'Admin',
  'absence.delete': 'Delete',
  'absence.confirm.delete': 'Really delete this absence?',
  'absence.error.save': 'Error saving',
};

export default absence;
